import React, { Component } from 'react';
import Header from '../Header';
import PubSub from 'pubsub-js';
import {prUrl, googleUrl} from '../config'

export default class Safari extends Component {
	state = {
		urlList: [],
		flag: -1,
		visitUrl: '',
		scale: 100,		
	}

	pushUrl = (url)=>{
		this.setState((prevState) => ({urlList: [...prevState.urlList.slice(0,prevState.flag+1) ,url], flag: prevState.flag + 1})); 
	}

	pushAndVisitUrl = (url)=>{
		this.setState((prevState) => ({urlList: [...prevState.urlList.slice(0,prevState.flag+1) ,url], flag: prevState.flag + 1, visitUrl: url})); 
	}

	getUrl = ()=>{
		return this.state.urlList[this.state.flag]
	}

	handleForward = () => {
		if (this.state.flag < this.state.urlList.length-1){
			this.setState((prevState) => ({flag: prevState.flag + 1, visitUrl:prevState.urlList[prevState.flag + 1]})); 
		}		
	}

	handleBackward = () => {
		if (this.state.flag > 0){
			this.setState((prevState) => ({flag: prevState.flag - 1, visitUrl:prevState.urlList[prevState.flag - 1]})); 
		}
	}

	setScale = (value) =>{
		this.setState({scale: value})
	}

	upScale = () =>{
		if (this.state.scale < 150){
			this.setState((prevState) => ({scale: prevState.scale + 10})); 
		}		
	}

	downScale = () =>{
		if (this.state.scale > 50){
			this.setState((prevState) => ({scale: prevState.scale - 10})); 
		}		
	}

	componentDidMount(){
		this.pushAndVisitUrl("https://www.google.com.hk/search?hl=zh-CN");
		// 订阅图谱侧推送的访问命令
		PubSub.subscribe("search",(_,keyword)=>{
			this.pushAndVisitUrl(googleUrl + keyword)
		})
		PubSub.subscribe("visit",(_,url)=>{
			this.pushAndVisitUrl(url)
		})
		// 定时监控iframe内url的变化，并填入地址栏
		var iframeWindow = document.getElementById('safariiframe').contentWindow;
		setInterval(() => {
			if (iframeWindow.getUrl){
				var iframeUrl = iframeWindow.getUrl()
				if (iframeUrl !== this.state.urlList[this.state.flag]){
					// console.log("url change to:", iframeUrl);
					this.pushUrl(iframeUrl)
				}
			}			
		}, 1000);
	}  

	render() {
		const {mode} = this.props
		const {urlList, flag, scale} = this.state
        return (
			<div id={'safari'} className={'safari'} style={{width: mode?'42vw':'100vw', left: mode?'58vw':'0vw'}}>
				<Header mode={this.props.mode} changeMode={this.props.changeMode} showUrl={flag>=0?urlList[flag]:''} pushAndVisitUrl={this.pushAndVisitUrl} 
					handleForward={this.handleForward} handleBackward={this.handleBackward}
					scale={this.state.scale} setScale={this.setScale} downScale={this.downScale} upScale={this.upScale}/>
				<iframe id={'safariiframe'} name={'safariiframe'} title={'safari'} src={prUrl + this.state.visitUrl} 
					style={{width: `${10000/scale}%`, height: `${8900/scale}%`, transform: "scale("+ scale/100 +")", zIndex:999}} />
			</div>
        )
    }
}
